"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayMin = void 0;
/**
 * zwraca minimalną wartość
 * @param values tablica wartości
 * @param prop sprawdzane property
 */
function arrayMin(values, prop) {
    let result = values[0];
    let i = values.length;
    if (prop) {
        while (--i > 0) {
            const $v = values[i][prop];
            if ($v < result) {
                result = $v;
            }
        }
    }
    else {
        while (--i > 0) {
            if (values[i] < result) {
                result = values[i];
            }
        }
    }
    return result;
}
exports.arrayMin = arrayMin;
//# sourceMappingURL=arrayMin.js.map